import { Button, Checkbox, Select, Space, Tabs } from 'antd';
import { useEffect, useState } from 'react'
import './BottomSetting.less';
import Icon from '@ant-design/icons'
import { SettingOutlined } from '@ant-design/icons';
const { TabPane } = Tabs;

// 假数据，用来模拟捕捉模式列表
const defaultCaptureModes = [
    { number: 1, name: '端点', active: true, icon: SettingOutlined },
    { number: 2, name: '中点', active: true, icon: SettingOutlined },
    { number: 3, name: '垂足', active: false, icon: SettingOutlined },
    { number: 4, name: '插入点', active: false, icon: SettingOutlined },
    { number: 5, name: '节点', active: false, icon: SettingOutlined },
    { number: 6, name: '中心点', active: false, icon: SettingOutlined },
    { number: 7, name: '象限点', active: false, icon: SettingOutlined },
    { number: 8, name: '最近点', active: false, icon: SettingOutlined },
    { number: 9, name: '交点', active: false, icon: SettingOutlined },
    { number: 10, name: '切点', active: false, icon: SettingOutlined },
];

interface IProps {
    selectedTabPane?: string, // 初始激活的页签
    onCancel?: () => void, // 取消按钮按下时的回调函数
}
export default function BottomSetting(props: IProps) {
    /**
     * 是否激活全选
     */
    const [checkAll, setCheckAll] = useState(false);
    /**
     * 是否处于半选状态
     */
    const [indeterminate, setIndeterminate] = useState(true);
    /**
     * 是否启用对象捕捉
     */
    const [capture, setCapture] = useState(true);
    /**
     * 捕捉模式列表
     */
    const [captureModes, setCaptureModes] = useState([]);
    /**
     * 初始化状态
     */
    useEffect(() => {
        setCaptureModes(defaultCaptureModes); // 设置初始状态
        updateCheckStatus(defaultCaptureModes); // 初始化全选和半选状态
    }, []);
    
    /**
     * 计算当前选中的捕捉模式，并更新全选和半选状态
     * @param {Array} modes - 当前捕捉模式列表
     */
    const updateCheckStatus = (modes) => {
        const activeCount = modes.filter((item) => item.active).length;
        setIndeterminate(activeCount > 0 && activeCount < modes.length);
        setCheckAll(activeCount === modes.length);
    };
    /**
     * 处理全选按钮的交互，使所有选项激活或取消激活
     * @param {Event} e - Checkbox的交互事件
     */
    const onCheckAllChange = (e) => {
        let modes = captureModes.map((mode) => {
            mode.active = e.target.checked
            return mode;
        });

        setCheckAll(e.target.checked);
        setIndeterminate(false);
        setCaptureModes(modes);
    };

    /**
     * 处理单个选项的状态切换，并更新全选和半选状态
     * @param {number} number - 选项的唯一编号
     * @param {boolean} active - 新的状态，是否激活
     */
    const onCaptureMenuItemClick = (number, active) => {
        let modes = captureModes.map((mode) => {
            if (mode.number === number) {
                mode.active = active; // 更新选中状态
            }
            return mode;
        });

        let num = modes.filter((item) => item.active).length; // 计算当前激活数
        setIndeterminate(num > 0 && num < modes.length); // 动态设置半选状态
        setCheckAll(num === modes.length); // 动态设置全选状态
        setCaptureModes(modes); // 更新状态
    };


    return (
        <div className="capture-setting-container">
            <Tabs defaultActiveKey={props.selectedTabPane} type="card" size="small">
                <TabPane tab="极轴追踪" key="polar">
                    <div className="manage-check">
                    </div>
                </TabPane>
                <TabPane tab="对象捕捉" key="capture">
                    <div className="manage-check">
                        <Checkbox onChange={() => {
                            setCapture(!capture)
                        }} checked={capture} >
                            启用对象捕捉（F3）
                        </Checkbox>
                        <span className="fill-remaining-space"></span>
                        <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
                            全选
                        </Checkbox>
                    </div>
                    <div className="capture-item-group">
                        {captureModes.map(item => (
                            <div className="capture-item" key={item.number}>
                                <Checkbox checked={item.active} onChange={() => onCaptureMenuItemClick(item.number, !item.active)}>
                                    <span>{item.name}</span>
                                </Checkbox>
                            </div>
                        ))}
                    </div>
                </TabPane>
            </Tabs>
            <div className="manage-foot">
                <span className="fill-remaining-space"></span>
                <Space size="small">
                    <Button size="small" onClick={props.onCancel}>确定</Button>
                    <Button size="small" onClick={props.onCancel}>取消</Button>
                </Space>

            </div>
        </div>
    )

}

